import {
    MEMBER_BLACKLIST_ADD_SUCCESS,
    MEMBER_FOLLOW_PROFILE_SUCCESS,
    MEMBER_BLACKLIST_DELETE_SUCCESS,
    MEMBER_UNFOLLOW_PROFILE_SUCCESS,
} from './member';

const GET_MEMBER_MESSAGEDIALOG_REQUEST = 'GET_MEMBER_MESSAGEDIALOG_REQUEST';
const GET_MEMBER_MESSAGEDIALOG_SUCCESS = 'GET_MEMBER_MESSAGEDIALOG_SUCCESS';
const GET_MEMBER_MESSAGEDIALOG_FAILURE = 'GET_MEMBER_MESSAGEDIALOG_FAILURE';

const GET_NEW_MEMBER_MESSAGEDIALOG_REQUEST = 'GET_NEW_MEMBER_MESSAGEDIALOG_REQUEST';
const GET_NEW_MEMBER_MESSAGEDIALOG_SUCCESS = 'GET_NEW_MEMBER_MESSAGEDIALOG_SUCCESS';
const GET_NEW_MEMBER_MESSAGEDIALOG_FAILURE = 'GET_NEW_MEMBER_MESSAGEDIALOG_FAILURE';

const ACTION_FILTER_MEMBER_MESSAGE_REQUEST = 'ACTION_FILTER_MEMBER_MESSAGE_REQUEST';
const ACTION_FILTER_MEMBER_MESSAGE_SUCCESS = 'ACTION_FILTER_MEMBER_MESSAGE_SUCCESS';
const ACTION_FILTER_MEMBER_MESSAGE_FAILURE = 'ACTION_FILTER_MEMBER_MESSAGE_FAILURE';

const SEND_MEMBER_MESSAGE_TO_DIALOG_REQUEST = 'SEND_MEMBER_MESSAGE_TO_DIALOG_REQUEST';
const SEND_MEMBER_MESSAGE_TO_DIALOG_SUCCESS = 'SEND_MEMBER_MESSAGE_TO_DIALOG_SUCCESS';
const SEND_MEMBER_MESSAGE_TO_DIALOG_FAILURE = 'SEND_MEMBER_MESSAGE_TO_DIALOG_FAILURE';

const DELETE_MEMBER_MESSAGE_TO_DIALOG_REQUEST = 'DELETE_MEMBER_MESSAGE_TO_DIALOG_REQUEST';
const DELETE_MEMBER_MESSAGE_TO_DIALOG_SUCCESS = 'DELETE_MEMBER_MESSAGE_TO_DIALOG_SUCCESS';
const DELETE_MEMBER_MESSAGE_TO_DIALOG_FAILURE = 'DELETE_MEMBER_MESSAGE_TO_DIALOG_FAILURE';

const CLEAR_MEMBER_MESSAGEDIALOG_IN_MEMORY_SUCCESS = 'CLEAR_MEMBER_MESSAGEDIALOG_IN_MEMORY_SUCCESS';

const initState = {
    count: 0,
    newCount: 0,
    unRead: false,
    totalCount: 0,
    trashCount: 0,
    newMessages: null,
    messageList: null,
};

import * as backend from 'backend-helpers/memberMessageDialog';

export default function memberMessageDialog(state = initState, action) {

    if (action.type === GET_MEMBER_MESSAGEDIALOG_SUCCESS) {
        let another = true;
        let message = null;

        let {
            offset,
            recipient,
            messageList
        } = action.result.data.data;

        let messageListReverse = messageList.reverse();

        if(state.recipient) another = state.recipient.user.id !== recipient.user.id;

        messageList = !another && offset > state.offset ? [...messageListReverse, ...state.messageList] : messageListReverse;

        return {
            ...state,
            ...action.result.data.data,
            message,
            messageList
        }
    }

    if (action.type === GET_NEW_MEMBER_MESSAGEDIALOG_SUCCESS) {
        let unRead;

        let {
            count,
            messageList
        } = action.result.data.data;

        let { offset } = action.data;


        let countNewMessages = count - state.count;

        if(countNewMessages !== 0) {
            state.newMessages = messageList.reverse().slice(-countNewMessages);

            unRead = true;
            state.count = state.count + countNewMessages;
            messageList = [...state.messageList, ...state.newMessages];

            return {
                ...state,
                unRead,
                messageList,
            }
        }
    }

    if (action.type === ACTION_FILTER_MEMBER_MESSAGE_SUCCESS && action.data.inDialogue) {
        state.newMessages.map((item, key) => item.old = 1);

        let unRead = false;

        return {
            ...state,
            unRead
        }
    }

    if (action.type === SEND_MEMBER_MESSAGE_TO_DIALOG_SUCCESS) {
        const {
            status,
            message,
        } = action.result.data;

        if(status === 'success') {
            state.count++;
            state.messageList.push(message);
        } else {
            return {
                ...state,
                ...action.result.data
            }
        }

        return state;
    }

    if (action.type === DELETE_MEMBER_MESSAGE_TO_DIALOG_SUCCESS) {
        const { id } = action.result.data;

        const index = state.messageList.findIndex(i => i.id === id);
        index > -1 ? state.messageList.splice(index, 1) : null;

        return state;
    }

    if (state.recipient && (action.type === MEMBER_FOLLOW_PROFILE_SUCCESS || action.type === MEMBER_UNFOLLOW_PROFILE_SUCCESS)) {
        let { followedByMe } = state.recipient;

        state.recipient.followedByMe = !followedByMe;

        return state;
    }

    if (state.recipient && (action.type === MEMBER_BLACKLIST_ADD_SUCCESS || action.type === MEMBER_BLACKLIST_DELETE_SUCCESS)) {
        let { blacklistedByMe } = state.recipient;

        state.recipient.blacklistedByMe = !blacklistedByMe;

        return state;
    }

    if (action.type === CLEAR_MEMBER_MESSAGEDIALOG_IN_MEMORY_SUCCESS) {
        state = initState;
    }

    return state;
}

export function getMemberMessageDialog(data) {
    return {
        types: [GET_MEMBER_MESSAGEDIALOG_REQUEST, GET_MEMBER_MESSAGEDIALOG_SUCCESS, GET_MEMBER_MESSAGEDIALOG_FAILURE],
        promise: backend.getMemberMessageDialog(data),
        data
    }
}

export function getNewMemberMessageDialog(data) {
    return {
        types: [GET_NEW_MEMBER_MESSAGEDIALOG_REQUEST, GET_NEW_MEMBER_MESSAGEDIALOG_SUCCESS, GET_NEW_MEMBER_MESSAGEDIALOG_FAILURE],
        promise: backend.getMemberMessageDialog(data),
        data
    }
}

export function sendMemberMessageToDialog(data) {
    return {
        types: [SEND_MEMBER_MESSAGE_TO_DIALOG_REQUEST, SEND_MEMBER_MESSAGE_TO_DIALOG_SUCCESS, SEND_MEMBER_MESSAGE_TO_DIALOG_FAILURE],
        promise: backend.sendMemberMessageToDialog(data),
        data
    }
}

export function deleteMemberMessageToDialog(data) {
    return {
        types: [DELETE_MEMBER_MESSAGE_TO_DIALOG_REQUEST, DELETE_MEMBER_MESSAGE_TO_DIALOG_SUCCESS, DELETE_MEMBER_MESSAGE_TO_DIALOG_FAILURE],
        promise: backend.deleteMemberMessageToDialog(data),
        data
    }
}

export function clearDialogInMemory(data) {
    return {
        type: CLEAR_MEMBER_MESSAGEDIALOG_IN_MEMORY_SUCCESS
    }
}


// WEBPACK FOOTER //
// ./src/reducers/memberMessageDialog.js